var map = {
	"./anhui.json": "5ab4",
	"./aomen.json": "6094",
	"./beijing.json": "b8c6",
	"./chongqing.json": "1268",
	"./fujian.json": "d372",
	"./gansu.json": "21d8",
	"./guangdong.json": "0c38",
	"./guangxi.json": "95ba",
	"./guizhou.json": "7b2e",
	"./hainan.json": "b907",
	"./hebei.json": "55a0",
	"./heilongjiang.json": "677f",
	"./henan.json": "2ad6",
	"./hubei.json": "e30e",
	"./hunan.json": "41b0",
	"./jiangsu.json": "ef65",
	"./jiangxi.json": "d75e",
	"./jilin.json": "7e0b",
	"./liaoning.json": "11c7",
	"./neimenggu.json": "9d40",
	"./ningxia.json": "b3137",
	"./qinghai.json": "5b90",
	"./shandong.json": "a9b6",
	"./shanghai.json": "d671",
	"./shanxi.json": "231d",
	"./shanxi1.json": "16c5",
	"./sichuan.json": "5100",
	"./taiwan.json": "40e4",
	"./tianjin.json": "9c02",
	"./xianggang.json": "298c",
	"./xinjiang.json": "6902",
	"./xizang.json": "716f",
	"./yunnan.json": "de38",
	"./zhejiang.json": "9091"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b411";